import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { initializeApp } from '@firebase/app'
import { doc, onSnapshot, getFirestore } from 'firebase/firestore'
import config from '../../config'
initializeApp(config.firebase)
const db = getFirestore()
export default function AnnouncementBox() {
  const admin = useSelector((state) => state.admin)
  const [announcements, setAnnouncements] = useState([])
  useEffect(() => {
    let unsub
    if (admin && admin.id) {
      unsub = onSnapshot(doc(db, 'admins', admin.id), (doc) => {
        const data = doc.data()
        data.announcements ? setAnnouncements(data.announcements) : setAnnouncements([])
      })
    }
    return () => {
      if (unsub) unsub()
    }
  }, [])
  return (
    <>
      <div className="d-flex justify-content-center">
        <marquee style={{ overflow: 'hidden', maxWidth: '960px' }}>
          <div className="d-flex justify-content-center align-items-center">
            {announcements.map((announcement, i) => (
              <div
                className="d-flex justify-content-center align-items-center"
                key={i}
                style={{ height: '40px', paddingRight: '100px' }}
              >
                {announcement.message}{' '}
                {announcement.link && (
                  <a
                    className="link-primary"
                    href={announcement.link}
                    alt={announcement.message}
                    style={{ marginLeft: '8px' }}
                    rel="noreferrer"
                    target="_blank"
                  >
                    ดูเพิ่มเติม
                  </a>
                )}
              </div>
            ))}
          </div>
        </marquee>
      </div>
    </>
  )
}
